export default "__VITE_ASSET__JZ0zbaof__"